module.exports = __webpack_public_path__ + "img/qrcode.93d7d9e1.jpg";